module.exports = __webpack_public_path__ + "static/media/poop.a741e355.svg";